/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Drop_FrameInputs */

const en_drop_frame = /** @type {(inputs: Drop_FrameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drop Frame`)
};

const fr_drop_frame = /** @type {(inputs: Drop_FrameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drop frame`)
};

const de_drop_frame = /** @type {(inputs: Drop_FrameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fallrahmen`)
};

const it_drop_frame = /** @type {(inputs: Drop_FrameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telaio a goccia`)
};

const ru_drop_frame = /** @type {(inputs: Drop_FrameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Опускающаяся рамка`)
};

const es_drop_frame = /** @type {(inputs: Drop_FrameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marco de caída`)
};

const zh_cn2_drop_frame = /** @type {(inputs: Drop_FrameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`掉帧`)
};

const ja_drop_frame = /** @type {(inputs: Drop_FrameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ドロップフレーム`)
};

const hi_drop_frame = /** @type {(inputs: Drop_FrameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ड्रॉप फ्रेम`)
};

const pt_pt2_drop_frame = /** @type {(inputs: Drop_FrameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quadro de queda`)
};

/**
* | output |
* | --- |
* | "Drop Frame" |
*
* @param {Drop_FrameInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const drop_frame = /** @type {((inputs?: Drop_FrameInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Drop_FrameInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_drop_frame(inputs)
	if (locale === "de") return de_drop_frame(inputs)
	if (locale === "it") return it_drop_frame(inputs)
	if (locale === "ru") return ru_drop_frame(inputs)
	if (locale === "es") return es_drop_frame(inputs)
	if (locale === "zh-CN") return zh_cn2_drop_frame(inputs)
	if (locale === "ja") return ja_drop_frame(inputs)
	if (locale === "hi") return hi_drop_frame(inputs)
	if (locale === "pt-PT") return pt_pt2_drop_frame(inputs)
	return en_drop_frame(inputs)
});